import {
	Select,
	Text,
	Textarea,
	Upload,
	TimeDuration,
	FormGroupInterface,
	VALIDATION_TYPE,
	FORM_TYPE,
	IAddressFields,
	IAddressRequired,
	GeoLocation
} from 'projects/common/src/app/types';
export function getAddressElements(
	address: any = {},
	on: any = {},
	fields: IAddressFields = {},
	fieldRequired: IAddressRequired = {},
	tccaf: any = false,
	parliamentary: any = false,
) {
	const addressForm: FormGroupInterface = {
		label: address.label || '',
		type: address.isPlane ? FORM_TYPE.WITHOUT_STYLE : FORM_TYPE.FORM,
		labelDiv: address.labelDiv,
		inputDiv: address.inputDiv,
		forms: [
			{
				label: address.subLabel || '',
				name: 'address',
				formElements: [
					new Text('Name', {
						name: 'name',
						required: fieldRequired.name,
						validationType: VALIDATION_TYPE.NAME,
						remove: !fields.name,
					}),
					new Textarea('Address:', {
						required: fieldRequired.detail,
						name: 'address1',
						validationType: VALIDATION_TYPE.ADDRESS_DETAIL,
						value: address.address,
						remove: !fields.detail,
						maxFieldLength: 500,
					}),
					new Text('Nearby Landmark:', {
						required: fieldRequired.landmark,
						name: 'landmark',
						value: address.landmark,
						// minFieldLength: 5,
						// maxFieldLength: 100,
						validationType: VALIDATION_TYPE.ADDRESS_LANDMARK,
						remove: !fields.landmark,
						// pattern: '[\\d\\w\\.\\-_\\/,&\\(\\)#:][\\d\\w\\. \\-_\\/,&\\(\\)#:]*$'
					}),
					new Text('Pincode:', {
						required: fieldRequired.pincode,
						name: 'pincode',
						validationType: VALIDATION_TYPE.PIN_CODE,
						value: address.pincode,
						onChange: on.pincodeChange,
						remove: !fields.pincode,
						charAllowedPattern: '[0-9]',
						maxFieldLength: 6
					}),
					new Select('State / Union Territory', address.states, {
						asyncLoad: true,
						name: 'state',
						required: fieldRequired.state,
						showAstrisk: true,
						remove: !fields.state,
						onChange: on.stateChange,
						value: getName(address.state)
					}),
					new Select('District:', address.districts, {
						required: fieldRequired.district,
						showAstrisk: true,
						name: 'district',
						asyncLoad: true,
						remove: !fields.district,
						onChange: on.districtChange,
						value: getName(address.district)
					}),
					new Select('Tehsil/Mandal/Block:', address.tehsils, {
						required: fieldRequired.tehsil,
						name: 'tehsil',
						asyncLoad: true,
						remove: !fields.tehsil,
						onChange: on.tehsilChange,
						value: getName(address.tehsil)
					}),
					new Select('City/Village/Town:', address.cities || [], {
						required: fieldRequired.city,
						name: 'city',
						asyncLoad: true,
						remove: !fields.city,
						onChange: on.cityChange,
						value: getName(address.city)
					}),
					new Text('City/Village/Town:', {
						required: fieldRequired.cityTextBox,
						name: 'City',
						validationType: VALIDATION_TYPE.NAME,
						value: address.cityTextBox,
						remove: !fields.cityTextBox,
						// charAllowedPattern: '[0-9]',
						// maxFieldLength: 6
					}),
					new Select(
						'Parliamentary Constituency:',
						address.parliamentaryConsistuencies,
						{
							required: fieldRequired.parliamentaryConstituency || parliamentary,
							// silentRequired: true,
							name: 'parliamentaryConstituency',
							showAstrisk: fieldRequired.parliamentaryConstituency || parliamentary,
							asyncLoad: true,
							remove: !fields.parliamentaryConstituency,
							onChange: on.parliamentaryConsistuencyChange,
							value: getName(address.parliamentaryConstituency)
						}
					),
					new GeoLocation(
						'Geo Location:', {
						placeholder: 'Enter Geo Location',
						required: fieldRequired.geoLocation,
						name: 'geoLocation',
						remove: !fields.geoLocation,
						onChange: on.geoLocationChange,
						value: address.geoLocation,
					}
					),
					new Select('Address Proof Type:',
						address.addressProofTypeOptions || [],
						{
							required: fieldRequired.addressProofType,
							showAstrisk: fieldRequired.addressProofType,
							remove: !fields.addressProofType,
							name: 'addressProofType',
							onChange: on.addressProofTypeChange,
							asyncLoad: true,
							value: address.addressProofType,
						}
					),
					new Upload(tccaf === true ? 'Document Proof' : 'Address Proof:', {
						required: fieldRequired.addressProof,
						showAstrisk: fieldRequired.addressProof,
						remove: !fields.addressProof,
						name: 'addressProof',
						maxSize: 5,
						// multi: ismultidoc && ismultidoc === true ? true : false,
						validationType: VALIDATION_TYPE.FILE,
						value: address.addressProof,
						allowedFormats: ['pdf', 'jpeg', 'png', 'jpg', 'docx']
					}),
					new Upload('Address Proofs :', {
						required: fieldRequired.multipleAddressProof,
						multi: true,
						maxSize: 5,
						remove: !fields.multipleAddressProof,
						name: 'multipleAddressProof',
						validationType: VALIDATION_TYPE.FILE,
						value: address.multipleAddressProof
					})
				]
			}
		]
	};
	return addressForm;
}

function getName(obj) {
	if (!obj) {
		return obj;
	}
	if (obj instanceof Object) {
		return obj.name;
	}
	return obj;
}
